export default value => (String(value).length < 2 ? `0${value}` : value)
